import axios from 'axios'
import Cookies from 'js-cookie'
import { Message } from 'element-ui'
import { VueAxios } from './axios'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 6000, // 请求超时时间
  withCredentials: true // 跨域请求时携带 Cookie（JSESSIONID）
})

const err = (error) => {
  if (error.response.request.responseType === 'blob') {
    const url = window.URL.createObjectURL(new Blob([error.response.data]))
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    a.setAttribute('download', '1.xlsx')
    document.body.appendChild(a)
    a.click() //执行下载
    window.URL.revokeObjectURL(a.href) //释放url
    document.body.removeChild(a) //释放标签
    return Promise.reject(error)
  }
  if (error.response) {
    const data = error.response.data
    console.log('error', error)
    if (data.code === 9001) {
      Message.error('登录状态失效')
      // 清除 Cookie 中的 JSESSIONID
      Cookies.remove('JSESSIONID')
      setTimeout(() => {
        window.location.href = '/'
      }, 1000)
    }
  }
  console.log('response===' + JSON.stringify(error.response.data))
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  // withCredentials: true 已开启，浏览器会自动携带后端设置的 JSESSIONID Cookie
  return config
}, err)

// response interceptor
request.interceptors.response.use((response) => {
  const data = response.data
  if (data.code === 9001) {
    Message.error('登录状态失效，请重新登录')
    Cookies.remove('JSESSIONID')
    setTimeout(() => {
      window.location.href = '/'
    }, 1000)
    return Promise.reject(data)
  }
  if (data.code !== 200) {
    Message.error(data.message || '操作失败')
    return Promise.reject(data)
  }
  return data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
